import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetByComanyRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateCabinetRequest, IExportCabinetRequest, IGetCabinetResponse, IUpdateCabinetRequest } from '../models/cabinet';


@Injectable({
  providedIn: 'root'
})
export class CabinetService {

  constructor(private http: HttpClient) { }

  // Cabinet
  createCabinet(request: ICreateCabinetRequest) {
    return this.http.post<IGetCabinetResponse>(
      `${environment.baseUrl}/v1/cabinets/createCabinet`,
      request
    )
  }

  getCabinetsByCompany(request: IBaseGetByComanyRequest){
    return this.http.post<IPagedResults<IGetCabinetResponse[]>>(
      `${environment.baseUrl}/v1/cabinets/searchCabinetsByCompany`,
      request
    )
  }

  getCabinetById(id: string){
    return this.http.get<IGetCabinetResponse>(
      `${environment.baseUrl}/v1/cabinets/getCabinet/${id}`
    )
  }

  updateCabinet(request: IUpdateCabinetRequest){
    return this.http.put<IGetCabinetResponse>(
      `${environment.baseUrl}/v1/cabinets/updateCabinet/${request.id}`,
      request
    )
  }

  deleteCabinet(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/cabinets/deleteCabinet/${id}`
    )
  }

  exportCabinet(request: IExportCabinetRequest){
    return this.http.post<Blob>(
      `${environment.baseUrl}/v1/cabinets/exportCabinet`,
      request,
      { 
        responseType: 'blob' as 'json',
        observe: 'response'
      } 
    )
  }
}
